export const environment = {
  reactAppDate: "28-05-2024 | 13:00",
  authUrl: "https://hn-production-users-service.azurewebsites.net/api/users/",
  contentUrl: "https://hn-production-content-service.azurewebsites.net/api/content/",
  usersUrl: "https://hn-production-users-service.azurewebsites.net/api/users/",
  msgUrl: "https://hn-production-messaging-service.azurewebsites.net/",
  linkpreview: "ff1be843f321b040e2786b8c401f691a",
  sfdcUrl: "https://hartman.my.salesforce.com/",
};
